import { render, staticRenderFns } from "./mdMapInvestor.vue?vue&type=template&id=0b8614c2&scoped=true"
import script from "./mdMapInvestor.vue?vue&type=script&lang=js"
export * from "./mdMapInvestor.vue?vue&type=script&lang=js"
import style0 from "./mdMapInvestor.vue?vue&type=style&index=0&id=0b8614c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8614c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8614c2')) {
      api.createRecord('0b8614c2', component.options)
    } else {
      api.reload('0b8614c2', component.options)
    }
    module.hot.accept("./mdMapInvestor.vue?vue&type=template&id=0b8614c2&scoped=true", function () {
      api.rerender('0b8614c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/hpPage/mdMapInvestor.vue"
export default component.exports